export const capitalize = (s: string) => {
  if (s === '') {
    return s;
  }
  return `${s.charAt(0).toUpperCase()}${s.substring(1)}`;
};
